
export default function OverviewSection() {
  const overviewData = [
    { label: '名称', value: '一般社団法人 未来ウェルビーイング協会' },
    { label: '英語名', value: 'Future Well-Being Association' },
    {
      label: '所在地',
      value: '〒542-0083\n大阪府大阪市中央区東心斎橋1丁目7-30\n21心斎橋ビル 3F',
    },
    { label: '代表理事', value: '森﨑 友紀' },
    { label: '設立', value: '2025年（令和7年）' },
    {
      label: '主な事業内容',
      value:
        'ボディスキャン・健康アドバイス事業、ウェルビーイング支援者育成、企業・地域向けプログラム開発、ペット共生社会の推進、LED光美容器を活用した健康支援 など',
    },
  ];

  return (
    <section id="overview" className="py-32 bg-white">
      <div className="max-w-[1200px] mx-auto px-10">
        <div className="grid lg:grid-cols-5 gap-16">
          {/* 左側：協会概要 */}
          <div className="lg:col-span-3">
            <p className="text-xs font-semibold tracking-widest bg-gradient-to-r from-[#4A90E2] to-[#50C9C3] bg-clip-text text-transparent mb-4">
              ABOUT ASSOCIATION
            </p>
            <h2 className="text-4xl font-bold text-[#1A2B3C] mb-12">協会概要</h2>

            {/* 概要テーブル */}
            <div className="bg-white rounded-2xl overflow-hidden border border-gray-200">
              {overviewData.map((item, index) => (
                <div
                  key={index}
                  className={`grid grid-cols-3 min-h-[64px] ${
                    index !== overviewData.length - 1 ? 'border-b border-gray-200' : ''
                  }`}
                >
                  <div className="col-span-1 bg-[#F7F9FB] px-6 py-5 flex items-center">
                    <span className="text-base font-semibold text-[#1A2B3C]">
                      {item.label}
                    </span>
                  </div>
                  <div className="col-span-2 bg-white px-6 py-5 flex items-center">
                    <span className="text-base text-[#3A4A5A] whitespace-pre-line leading-relaxed">
                      {item.value}
                    </span>
                  </div>
                </div>
              ))}
            </div>
          </div>

          {/* 右側：アクセス */}
          <div className="lg:col-span-2">
            <p className="text-xs font-semibold tracking-widest bg-gradient-to-r from-[#4A90E2] to-[#50C9C3] bg-clip-text text-transparent mb-4">
              ACCESS
            </p>
            <h2 className="text-4xl font-bold text-[#1A2B3C] mb-8">アクセス</h2>

            {/* アクセス詳細 */}
            <div className="space-y-5 mb-8">
              <div className="flex items-start gap-3">
                <i className="ri-subway-line text-xl text-[#4A90E2] mt-1 w-6 h-6 flex items-center justify-center"></i>
                <div className="text-[15px] leading-relaxed text-[#3A4A5A]">
                  <strong className="block mb-1">大阪メトロ 御堂筋線・長堀鶴見緑地線</strong>
                  「心斎橋駅」6番出口より徒歩5分
                </div>
              </div>
              <div className="flex items-start gap-3">
                <i className="ri-subway-line text-xl text-[#4A90E2] mt-1 w-6 h-6 flex items-center justify-center"></i>
                <div className="text-[15px] leading-relaxed text-[#3A4A5A]">
                  <strong className="block mb-1">大阪メトロ 堺筋線・長堀鶴見緑地線</strong>
                  「長堀橋駅」7番出口より徒歩4分
                </div>
              </div>
            </div>

            {/* 地図 */}
            <div className="rounded-2xl overflow-hidden border border-gray-200 h-[280px]">
              <iframe
                src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3281.0234567890123!2d135.50230000000002!3d34.673800000000004!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0x0!2zMzTCsDQwJzI1LjciTiAxMzXCsDMwJzA4LjMiRQ!5e0!3m2!1sja!2sjp!4v1234567890123!5m2!1sja!2sjp"
                width="100%"
                height="100%"
                style={{ border: 0 }}
                allowFullScreen
                loading="lazy"
                referrerPolicy="no-referrer-when-downgrade"
                title="協会所在地"
              ></iframe>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
